import React from "react";
import CreateInvoiceForm from "../components/CreateInvoiceForm";

function CreateInvoice() {
  return <div className="create-invoice-form"><CreateInvoiceForm /></div>;
}

export default CreateInvoice;
